import { render } from "./SupportToolModal.vue?vue&type=template&id=a8d9fc8a&scoped=true&ts=true"
import script from "./SupportToolModal.vue?vue&type=script&lang=ts"
export * from "./SupportToolModal.vue?vue&type=script&lang=ts"

import "./SupportToolModal.vue?vue&type=style&index=0&id=a8d9fc8a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d9fc8a"]])

export default __exports__